import BaseHistoryRecordModel from '../BaseHistoryRecordModel';
import { HistoryRecordDto } from '../../services/types';

export default class ProjectHistoryRecordModel extends BaseHistoryRecordModel {
    constructor(data: HistoryRecordDto) {
        super(data);
    }

    get objectLabel() {
        return this.importSummary
            ? `Project imported · ${this.importSummary.totalObjects.toLocaleString()} configuration objects affected`
            : 'Project';
    }
}
